export const FOOTER = {
  SET_OFFSET_LEFT: {
    MAIN: 'SET_OFFSET_LEFT',
    SUCCESS: 'SET_OFFSET_LEFT_SUCCESS',
    FAILURE: 'SET_OFFSET_LEFT_FAILURE'
  }
}
